export default "__VITE_ASSET__Cg9Z4Tvb__"